module.exports = __webpack_public_path__ + "img/yuanjingV2New.31bb44fe.png";